namespace('compass.group');

compass.requireLib('compass.util.parse');
compass.requireLib('compass.util.format');

compass.group.GDSInfoWidget = compass.defineWidget(function GDSInfoWidget (options) {
	var me = this;
	var $j = jQuery;
	var d = jQuery.dom.getContext(this);

	var _settings = options;

	var GDS_LABEL = '(Web Rate)';
	var RATE_LABEL = "avg nightly web rate";
	var CONTACT_INFO = "Web Rate reservations cannot be modified online.  To make changes to or cancel your reservation, please contact the hotel directly at %P.";
	var RES_DATE = "Please note: changes made with the hotel directly will not be reflected online.  All information displayed here is as of %D.";
	var _rangeFormatter = compass.util.dateFormatter('ddd, mmm d');
	var _numFormatter = _settings.meetingInfo.defaultDateFormatter;
	var _cf = _settings.meetingInfo.defaultCurrencyFormatter;

	me.render = function (widgetElem) {
		widgetElem.append(_makeHotelName());
		widgetElem.append(_makeRoomSummary());
		widgetElem.append(_makeRoomName());
		widgetElem.append(_makeReservationInfo());
	};

	var _makeHotelName = function () {
		return d.div({}, d.div({
			className: 'hotelName'
		}, _settings.hotelName + " " + GDS_LABEL),
		d.div({
			className: 'hotelRate'
		}, _cf(_settings.rate) + " | " + RATE_LABEL)
		);
	};

	var _makeRoomSummary = function () {
		var roomCount = _settings.roomCount.toString();
		roomCount += _settings.roomCount > 1 ? " rooms" : " room";

		var stayRange = _rangeFormatter(
				compass.util.parse.ISODateParser(_settings.checkIn)
			) + " - " + _rangeFormatter(
				compass.util.parse.ISODateParser(_settings.checkOut)
			);

		return d.div({
			className: 'roomSummary'
		}, roomCount + " (" + stayRange + ")");
	};

	var _makeRoomName = function () {
		return d.div({
			className: 'roomName'
		}, _settings.roomType);
	};

	var _makeReservationInfo = function () {
		return d.div({
			className: 'reservationInfo'
		}, d.div({ }, CONTACT_INFO.replace("%P", _settings.hotelContact)),
			d.div({ }, RES_DATE.replace("%D", _settings.bookingDate.length > 0 ? _numFormatter(
				compass.util.parse.ISODateParser(_settings.bookingDate)
			) : ""))
		);
	};
}, {
	WUID: 'DEFAULT',
	widgetName: "GDSInfoWidget",
	meetingInfo : { }
});
